import React from 'react';
import { Link } from 'react-router-dom';
import { Book, FileText, Mail, Lightbulb, Brain } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import LanguageSwitcher from './LanguageSwitcher';

const Header = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-sm z-50 border-b border-cyan-100" role="banner">
      <nav className="container mx-auto px-6 py-4" aria-label="Main navigation">
        <div className="flex items-center justify-between">
          <Link 
            to="/" 
            className="flex items-center space-x-2 hover:opacity-80 transition-opacity"
            aria-label="Go to homepage"
          >
            <Brain className="w-8 h-8 text-cyan-600" aria-hidden="true" />
            <span className="text-xl font-bold bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent">
              Lumi Labs
            </span>
          </Link>
          
          <div className="hidden md:flex items-center space-x-8">
            <NavLink href="#services" icon={<Lightbulb className="w-4 h-4" />} text={t.nav.services} />
            <NavLink href="#courses" icon={<Book className="w-4 h-4" />} text={t.nav.courses} />
            <NavLink href="#materials" icon={<FileText className="w-4 h-4" />} text={t.nav.materials} />
            <NavLink href="#contact" icon={<Mail className="w-4 h-4" />} text={t.nav.contact} />
            <LanguageSwitcher />
          </div>
        </div>
      </nav>
    </header>
  );
};

const NavLink = ({ href, icon, text }: { href: string; icon: React.ReactNode; text: string }) => (
  <a
    href={href}
    className="flex items-center space-x-1 text-gray-600 hover:text-cyan-600 transition-colors focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 rounded-md"
    aria-label={text}
  >
    {React.cloneElement(icon as React.ReactElement, { 'aria-hidden': 'true' })}
    <span>{text}</span>
  </a>
);

export default Header;